import { Controller } from "stimulus";

// Connects to data-controller="production-chart"
export default class extends Controller {
  static targets = ['startDate', 'endDate', 'timestamp'];

  connect() {
    this.daySwitchHour = 12;
    this.initializeFromURL();
    setInterval(() => this.refresh(), 30000);
  }

  initializeFromURL() {
    const urlParams = new URLSearchParams(window.location.search);

    // Read from URL params first, then form fields, then default to today
    this.startDate = this.parseDateFromParam(urlParams.get('start_date')) ||
                     this.getDateFromTarget('startDate') ||
                     new Date();

    this.endDate = this.parseDateFromParam(urlParams.get('end_date')) ||
                   this.getDateFromTarget('endDate') ||
                   this.startDate;

    this.updateFormFields();
  }

  parseDateFromParam(param) {
    return param ? new Date(param) : null;
  }

  getDateFromTarget(targetName) {
    const target = this[`${targetName}Target`];
    return target?.value ? new Date(target.value) : null;
  }

  updateFormFields() {
    this.setTargetValue('startDate', this.formatDate(this.startDate));
    this.setTargetValue('endDate', this.formatDate(this.endDate));
  }

  setTargetValue(targetName, value) {
    const target = this[`${targetName}Target`];
    if (target) target.value = value;
  }

  formatDate(date) {
    return date.toISOString().substring(0, 10);
  }

  syncDatesFromForm() {
    this.startDate = this.getDateFromTarget('startDate') || this.startDate;
    this.endDate = this.getDateFromTarget('endDate') || this.endDate;
  }

  moveDates(direction) {
    this.syncDatesFromForm();
    this.startDate.setDate(this.startDate.getDate() + direction);
    this.endDate.setDate(this.endDate.getDate() + direction);
    this.updateFormFields();
    this.updateURL();
  }

  updateURL() {
    const url = new URL(window.location);
    url.searchParams.set('start_date', this.formatDate(this.startDate));
    url.searchParams.set('end_date', this.formatDate(this.endDate));

    // Use Turbo's built-in URL update
    window.history.replaceState({}, '', url);
  }

  next() {
    this.moveDates(1);
    this.refresh();
  }

  prev() {
    this.moveDates(-1);
    this.element.requestSubmit();
  }

  home() {
    const today = new Date();
    this.startDate = new Date(today);
    this.endDate = new Date(today);

    if (today.getHours() >= this.daySwitchHour) {
      this.startDate.setDate(this.startDate.getDate() + 1);
      this.endDate.setDate(this.endDate.getDate() + 1);
    }

    this.updateFormFields();
    this.updateURL();
    this.refresh();
  }

  refresh() {
    this.setTargetValue('timestamp', new Date().toISOString());
    this.element.requestSubmit();
  }
}
